import { render } from "./DialogCliente.vue?vue&type=template&id=9c72c846"
import script from "./DialogCliente.vue?vue&type=script&lang=js"
export * from "./DialogCliente.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__